import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ClickAnalyticsPlugin } from '@microsoft/applicationinsights-clickanalytics-js';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { createBrowserHistory } from 'history';

const clickPluginInstance = new ClickAnalyticsPlugin();
const reactPlugin = new ReactPlugin();
let appInsights;

// Set the basename to match app's routing
const browserHistory = createBrowserHistory({ basename: '/oss_redesign/ui-modules_redesign/' });

// Click Analytics configuration
const clickPluginConfig = {
    dataTags: {
        useDefaultContentNameOrId: true,
        autoCapture: true,
    },
};

// function to fetch Application Insights configuration
const fetchAppInsightsConfig = async () => {
    try {
        // Fetch the Application Insights configuration from the server/backend
        const response = await fetch('/application-insights');
        const config = await response.json();

        //extract the connection string from the response
        const connectionString = config.appInsightsConnectionString;

        appInsights = new ApplicationInsights({
            config: {
                connectionString: connectionString,
                enableAutoRouteTracking: true,
                //enableCorsCorrelation: true,
                disableFetchTracking: false,
                disableAjaxTracking: false,
                extensions: [clickPluginInstance, reactPlugin],
                extensionConfig: {
                    [clickPluginInstance.identifier]: clickPluginConfig,
                    [reactPlugin.identifier]: {
                        history: browserHistory,
                    },
                },
            },
        });
        appInsights.loadAppInsights();
    } catch (error) {
        console.error('Error fetching Application Insights config:', error);
    }
};

fetchAppInsightsConfig();

export { reactPlugin, appInsights };
